import {
  barIcon_1,
  barIcon_2,
  barIcon_25,
  barIcon_3,
  barIcon_4,
  barIcon_5,
  barIcon_6,
  barIcon_7,
} from "./icons"
import { BarId, DiggerId, MileId } from "./enums"

export interface Mile {
  title: string
  id: MileId
  paths: boolean
  date: string
  done: boolean
  icon: L.Icon
  image:
    | "bar1"
    | "bar2"
    | "bar25"
    | "bar3"
    | "bar4"
    | "bar5"
    | "bar6"
    | "bar7"
    | "extra"
    | "denied"
  diggers: DiggerId[]
  bars: BarId[]
}

export const miles: Mile[] = [
  {
    title: "Первая миля",
    id: MileId.Mile1,
    paths: true,
    date: "26 февраля 2023",
    done: true,
    icon: barIcon_1,
    image: "bar1",
    diggers: [DiggerId.Kvertinsky, DiggerId.Kokos, DiggerId.Lex, DiggerId.Kot],
    bars: [
      BarId.Samocvet,
      BarId.DvaDeda,
      BarId.Health,
      BarId.Irish,
      BarId.InnocentPeople,
      BarId.Pravda,
      BarId.NeBar,
    ],
  },
  {
    title: "Вторая миля",
    id: MileId.Mile2,
    paths: true,
    date: "10 марта 2023",
    done: true,
    icon: barIcon_2,
    image: "bar2",
    diggers: [
      DiggerId.Kvertinsky,
      DiggerId.Jopa,
      DiggerId.Lex,
      DiggerId.Dima,
      DiggerId.Eduard,
      DiggerId.Evgenia,
      DiggerId.Ge,
      DiggerId.Gleb,
      DiggerId.Ilya,
      DiggerId.Lada,
      DiggerId.Mihael,
      DiggerId.Lena,
      DiggerId.Kokos,
      DiggerId.An,
    ],
    bars: [
      BarId.Mon,
      BarId.Sova,
      BarId.Mango,
      BarId.Kaifooi,
      BarId.OurBar,
      BarId.Nravs,
      BarId.NewBar,
    ],
  },
  {
    title: "Миля 2.5",
    id: MileId.Mile25,
    paths: true,
    date: "24 марта 2023",
    done: true,
    icon: barIcon_25,
    image: "bar25",
    diggers: [
      DiggerId.Kvertinsky,
      DiggerId.Jopa,
      DiggerId.Kot,
      DiggerId.Kokos,
      DiggerId.Lada,
    ],
    bars: [
      BarId.Spletni,
      BarId.InTouch,
      BarId.Izakaya,
      BarId.Kritik,
      BarId.Melody,
      BarId.SleepingDog,
      BarId.Mivino,
    ],
  },
  {
    title: "Третья миля",
    id: MileId.Mile3,
    paths: true,
    date: "31 марта 2023",
    done: true,
    icon: barIcon_3,
    image: "bar3",
    diggers: [
      DiggerId.Kvertinsky,
      DiggerId.Kokos,
      DiggerId.Jopa,
      DiggerId.Artem,
      DiggerId.Evgenia,
      DiggerId.Lena,
      DiggerId.Lada,
      DiggerId.Kot,
      DiggerId.Plur,
    ],
    bars: [
      BarId.Television,
      BarId.Strelka,
      // BarId.Sbors,
      // BarId.Slova,
      BarId.Collective,
      // BarId.DoubleGrill,
      BarId.Gastrols,
      // BarId.Fireside,
      BarId.Baiks,
      // BarId.Tarantino,
    ],
  },
  {
    title: "Четвёртая миля",
    id: MileId.Mile4,
    paths: true,
    date: "28 июня 2023",
    done: true,
    icon: barIcon_4,
    image: "bar4",
    diggers: [
      DiggerId.Kvertinsky,
      DiggerId.Kokos,
      DiggerId.Artem,
      DiggerId.Lada,
      DiggerId.Plur,
    ],
    bars: [
      BarId.Fjord,
      BarId.Nelson,
      BarId.Health,
      BarId.Fjord,
      BarId.Amigos,
      BarId.Stavnikov,
      BarId.Pils,
      BarId.Geograf,
      BarId.Spletni,
      BarId.Collective,
    ],
  },
  {
    title: "Пятая миля",
    id: MileId.Mile5,
    paths: true,
    date: "13 октября 2023 | 20:00",
    done: true,
    icon: barIcon_5,
    image: "bar5",
    diggers: [
      DiggerId.Kvertinsky,
      DiggerId.Kokos,
      DiggerId.Artem,
      DiggerId.Vadim,
      DiggerId.Lada,
      DiggerId.Maria,
      DiggerId.Plur,
      DiggerId.Sasha,
      DiggerId.Ivan,
      DiggerId.Alexa,
      DiggerId.Anatoly,
    ],
    bars: [
      BarId.Health,
      BarId.Podpolie,
      BarId.Spletni,
      BarId.Pils,
      BarId.SleepingDog,
    ],
  },
  {
    title: "Шестая миля",
    id: MileId.Mile6,
    paths: true,
    date: "2 декабря 2023 | 18:00",
    done: true,
    icon: barIcon_6,
    image: "bar6",
    diggers: [
      DiggerId.Kvertinsky,
      DiggerId.Sevara,
      DiggerId.Plur,
      DiggerId.Mashulkins,
      DiggerId.Anton,
    ],
    bars: [BarId.Health, BarId.Television, BarId.Samocvet, BarId.Health],
  },
  {
    title: "Седьмая миля",
    id: MileId.Mile7,
    paths: true,
    date: "6 декабря 2023 | 20:00",
    done: true,
    icon: barIcon_7,
    image: "bar7",
    diggers: [
      DiggerId.Kvertinsky,
      DiggerId.Lada,
      DiggerId.Mihael,
      DiggerId.Vadim,
    ],
    bars: [
      BarId.Health,
      BarId.Samocvet,
      BarId.Collective,
      BarId.Fjord,
      BarId.Salut,
      BarId.Yankee,
      BarId.Opyt,
      BarId.Melody,
      BarId.SleepingDog,
      BarId.Pocherk,
    ],
  },
]
